export const START_LOGIN_REQUEST = "START_LOGIN_REQUEST";
export const END_LOGIN_REQUEST = "END_LOGIN_REQUEST";
export const ABORT_LOGIN_REQUEST = "ABORT_LOGIN_REQUEST";


export const CHECK_LOGIN_REQUEST = "CHECK_LOGIN_REQUEST";

export const REMOVE_LOGIN_DATA =  "REMOVE_LOGIN_DATA";